import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';


export default function About() {

    return (
        <div>
            <Navigation/>
            <section className="hero-wrap hero-wrap-2" style={{ backgroundImage: 'url("./images/day2.png")' }} data-stellar-background-ratio="3">
                <div className="overlayy1"/>
                <div className="container">
                    <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
                        <div className="col-md-9 ftco-animate pb-0 text-center">
                            {/* <p className="breadcrumbs"><span className="mr-2"><a href="/">Home <i className="fa fa-chevron-right"></i></a></span> <span>About us <i className="fa fa-chevron-right"></i></span></p>
                            <h1 className="mb-3 bread">About Us</h1> */}
                            <h1 className="mb-3 bread">ABOUT US</h1>
                            <span style={{ color: 'white' }}>WE ARE EXPERIENCED & WELL RECOGNIZED <br /> IN THE FIELD OF CONSTRUCTION & DELIVERING HIGH QUALITY PROJECTS.</span>

                        </div>
                    </div>
                </div>
            </section>






            <section className="ftco-section ftco-no-pb ftco-no-pt" id="aboutus">
                <div className="container">
                    <div className="row justify-content-center mb-5 mt-5">
                        <div className="col-md-7 text-center heading-section ftco-animate">
                            <span className="subheading">Who We Are ?</span>
                            <h2 className="mb-3">About Us</h2>
                        </div>
                    </div>
                    <div className="row">
                        {/* <div className="col-md-7 order-md-last d-flex align-items-stretch">
                            <div className="img w-100 img-2 mr-md-2" style={{
                                backgroundImage: 'url(images/about.jpg)'
                            }}></div>
                            <div className="img w-100 img-2 ml-md-2" style={{ backgroundImage: 'url(images/about-2.jpg)' }}></div>
                        </div> */}

                        <div className='col-md-5 pt-0 ftco-animate pt-lg-5 pt-md-5 pt-sm-5'>
                            <div className="d-flex flex-column justify-content-center align-items-center" id="yrsBox" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1542718786-2e81a9d3dfac?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80)',backgroundPosition:"25% 20%",backgroundSize:"cover",height:"100%" }}>
                                        <div className="d-flex flex-column justify-content-center align-items-center" style={{background:"rgba(255,255,255,1)",width:"80%",height:"80%"}}>
                                            <div className="ftco-animate">
                                            <h2 id="layer1" className="font-weight-bold display-1 text-center" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1542718786-2e81a9d3dfac?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80)',backgroundPosition:"25% 20%",backgroundSize:"cover"}}>30</h2>
                                            <p id="layer2" className="font-weight-bold text-center display-4" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1542718786-2e81a9d3dfac?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80)',backgroundPosition:"25% 20%",backgroundSize:"cover"}}>Years Of Experience</p>
                                            </div>
                                        </div>
                            </div>
                        </div>

                        <div className='col-md-7 pl-lg-5 pl-md-5 pl-sm-5 pl-4 pt-5'>


                            <div className=" wrap-about py-md-5 ftco-animate">
                                <div className="heading-section">
                                    <h2 className="mb-4 text-lg-left text-sm-center text-center whitespace">About <span className="text-success"> Dream Home </span> Colonisers</h2>

                                    <h4 className="mb-4 text-success font-weight-bold"> Vision</h4>
                                    <p >
                                        Our vision is to be one of India’s Leading, Most Admired & Trusted Real Estate Company. We truly want to turn everyone’s Real Estate Dreams into reality.</p>
                                    <h4 className="mb-4 text-success font-weight-bold">Mission</h4>
                                    <p >
                                        The company’s mission as a real estate company is to develop and deliver unique, integrated lifestyle and work place environments through its focus on high quality architecture, strong project execution, affordable prices and its customer-centric approach. We want to enhance the overall quality of life through modern, affordable & sustainable infrastructure.</p>

                                </div>
                            </div>

                        </div>


                        <div className='col-md-12 pl-lg-5 pl-md-5 pl-sm-5 pl-4'>
                            <div className=" wrap-about py-md-5 ftco-animate">
                                <div className="heading-section">
                                    <h4 className="mb-4 text-success font-weight-bold">About us</h4>
                                    <p >
                                        Dreamhome Developers & Colonisers is a company that has come into being to turn the real estate dreams of normal people in our society into actual realities. The vision to provide affordable and modern housing to everyone led to the formation of this company!
With over an experience of 30 years, the team of Dreamhome started this organization to actualize their mission. They are licensed colonizers who work with transparency, honesty and credibility. They focus on delivering high quality standards by following meticulously planned approach. We value the faith of our clients and ensure timely delivery of innovative & quality products.</p>
                                    <p >We are here to build vibrant communities that redefine real estate development in Punjab. </p>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </section>

            {/*<section className="ftco-counter img" id="section-counter">*/}
            {/*    <div className="container">*/}
            {/*        <div className="row pt-md-5">*/}
            {/*            <div className="col-md-6 col-lg-3 justify-content-center counter-wrap ftco-animate">*/}
            {/*                <div className="block-18 py-5 mb-4">*/}
            {/*                    <div className="text text-border d-flex align-items-center">*/}
            {/*                        <strong className="number" data-number="1000">0</strong>*/}
            {/*                        <span>Area <br />Population</span>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="col-md-6 col-lg-3 justify-content-center counter-wrap ftco-animate">*/}
            {/*                <div className="block-18 py-5 mb-4">*/}
            {/*                    <div className="text text-border d-flex align-items-center">*/}
            {/*                        <strong className="number" data-number="2500">0</strong>*/}
            {/*                        <span>Total <br />Properties</span>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="col-md-6 col-lg-3 justify-content-center counter-wrap ftco-animate">*/}
            {/*                <div className="block-18 py-5 mb-4">*/}
            {/*                    <div className="text text-border d-flex align-items-center">*/}
            {/*                        <strong className="number" data-number="500">0</strong>*/}
            {/*                        <span>Average <br />House</span>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*            <div className="col-md-6 col-lg-3 justify-content-center counter-wrap ftco-animate">*/}
            {/*                <div className="block-18 py-5 mb-4">*/}
            {/*                    <div className="text d-flex align-items-center">*/}
            {/*                        <strong className="number" data-number="67">0</strong>*/}
            {/*                        <span>Total <br />Branches</span>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</section>*/}

            <section className="ftco-section testimony-section bg-darken" id="happyclients">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-md-7 text-center heading-section ftco-animate">
                            <span className="subheading">Testimonial</span>
                            <h2 className="mb-3 text-white">Happy Clients</h2>
                        </div>
                    </div>
                    <div className="row ftco-animate">
                        <div className="col-md-12">
                            <div className="carousel-testimony owl-carousel">
                                <div className="item">
                                    <div className="testimony-wrap py-4">
                                        <div className="text">
                                            <span className="fa fa-quote-left"></span>
                                            <p className="mb-4">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>
                                            <div className="d-flex align-items-center">
                                                <div className="user-img" style={{
                                                    backgroundImage: 'url(images/person_1.jpg)'
                                                }}></div>
                                                <div className="pl-3">
                                                    <p className="name">Roger Scott</p>
                                                    <span className="position">Marketing Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="testimony-wrap py-4">
                                        <div className="text">
                                            <span className="fa fa-quote-left"></span>
                                            <p className="mb-4">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>
                                            <div className="d-flex align-items-center">
                                                <div className="user-img" style={{
                                                    backgroundImage: 'url(images/person_2.jpg)'
                                                }}></div>
                                                <div className="pl-3">
                                                    <p className="name">Roger Scott</p>
                                                    <span className="position">Marketing Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="testimony-wrap py-4">
                                        <div className="text">
                                            <span className="fa fa-quote-left"></span>
                                            <p className="mb-4">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>
                                            <div className="d-flex align-items-center">
                                                <div className="user-img" style={{
                                                    backgroundImage: 'url(images/person_3.jpg)'
                                                }}></div>
                                                <div className="pl-3">
                                                    <p className="name">Roger Scott</p>
                                                    <span className="position">Marketing Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="testimony-wrap py-4">
                                        <div className="text">
                                            <span className="fa fa-quote-left"></span>
                                            <p className="mb-4">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>
                                            <div className="d-flex align-items-center">
                                                <div className="user-img" style={{
                                                    backgroundImage: 'url(images/person_1.jpg)'
                                                }}></div>
                                                <div className="pl-3">
                                                    <p className="name">Roger Scott</p>
                                                    <span className="position">Marketing Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="testimony-wrap py-4">
                                        <div className="text">
                                            <span className="fa fa-quote-left"></span>
                                            <p className="mb-4">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>
                                            <div className="d-flex align-items-center">
                                                <div className="user-img" style={{
                                                    backgroundImage: 'url(images/person_2.jpg)'
                                                }}></div>
                                                <div className="pl-3">
                                                    <p className="name">Roger Scott</p>
                                                    <span className="position">Marketing Manager</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ftco-section ftco-no-pb ftco-no-pt bg-primary pt-5" id="whychooseus">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 heading-section text-center ftco-animate mb-5">
                            <h2 className="mb-2 text-white">Why Choose Us ?</h2>
                        </div>
                    </div>
                    <div className="row d-flex no-gutters">
                        <div className="col-md-3 d-flex align-items-stretch ftco-animate">
                            <div className="media block-6 services services-bg d-block text-center px-4 py-5">
                                <div className="icon d-flex justify-content-center align-items-center"><span className="flaticon-business"></span></div>
                                <div className="media-body py-md-4">
                                    <h3>Trusted by Thousands</h3>
                                    <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex align-items-stretch ftco-animate">
                            <div className="media block-6 services services-bg services-darken d-block text-center px-4 py-5">
                                <div className="icon d-flex justify-content-center align-items-center"><span className="flaticon-home"></span></div>
                                <div className="media-body py-md-4">
                                    <h3>Over 30 Years Of Experience</h3>
                                    <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex align-items-stretch ftco-animate">
                            <div className="media block-6 services services-bg services-lighten d-block text-center px-4 py-5">
                                <div className="icon d-flex justify-content-center align-items-center"><span className="flaticon-stats"></span></div>
                                <div className="media-body py-md-4">
                                    <h3>Government Licensed Colonisers</h3>
                                    <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex align-items-stretch ftco-animate">
                            <div className="media block-6 services services-bg d-block text-center px-4 py-5">
                                <div className="icon d-flex justify-content-center align-items-center"><span className="flaticon-quarantine"></span></div>
                                <div className="media-body py-md-4">
                                    <h3>Timely Delivery</h3>
                                    <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="ftco-section ftco-no-pb ftco-no-pt bg-primary">
                <div className="container">
                    <div className="row d-flex no-gutters">
                        <div className="col-md-3 d-flex align-items-stretch ftco-animate">
                            <div className="media block-6 services services-bg d-block text-center px-4 py-5">
                                <div className="icon d-flex justify-content-center align-items-center"><span className="flaticon-business"></span></div>
                                <div className="media-body py-md-4">
                                    <h3>Committed To Excellence</h3>
                                    <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex align-items-stretch ftco-animate">
                            <div className="media block-6 services services-bg services-darken d-block text-center px-4 py-5">
                                <div className="icon d-flex justify-content-center align-items-center"><span className="flaticon-home"></span></div>
                                <div className="media-body py-md-4">
                                    <h3>Customer Satisfaction is Key</h3>
                                    <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex align-items-stretch ftco-animate">
                            <div className="media block-6 services services-bg services-lighten d-block text-center px-4 py-5">
                                <div className="icon d-flex justify-content-center align-items-center"><span className="flaticon-stats"></span></div>
                                <div className="media-body py-md-4">
                                    <h3>Financial Assistance</h3>
                                    <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 d-flex align-items-stretch ftco-animate">
                            <div className="media block-6 services services-bg d-block text-center px-4 py-5">
                                <div className="icon d-flex justify-content-center align-items-center"><span className="flaticon-quarantine"></span></div>
                                <div className="media-body py-md-4">
                                    <h3>EMI Facility Available</h3>
                                    <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="hero-wrap hero-wrap-2 bg-darken" id="contactus">

                <div className="container">
                    <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
                        <div className="col-md-9 ftco-animate pb-0 text-center p-2 p-lg-5 p-md-5 p-md-5">

                            {/*<h2 style={{ color: 'white' }}>GET A <span className="text-success font-weight-bold">FREE QUOTATION</span> TODAY!</h2>*/}
                            <h4 style={{ color: 'white' }}>CREATING REAL VALUE IN <span className="text-success font-weight-bold">REAL ESTATE</span></h4>
                            <p className="text-center">Have Any Questions Feel Free To Ask !</p>
                            <h6 style={{ color: 'white' }}>
                                Say Hello, <span className="text-success font-weight-bold">+91 9814206896</span> Or</h6>
                            <div className='container mt-5'>
                                <a className='btn-lg btn-success' href='/contact'>Contact Us</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer></Footer>


        </div>
    );
}